import { apiSlice } from "./apiSlice";

export const projectRiskSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllProjectRisk: builder.query({
            query: (params) => ({
                url: `ProjectRisk`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProjectRisks"],
        }),

        // Export all data (without pagination) in Excel File
        getExportAllProjectRisk: builder.query({
            query: (params) => ({
                url: `ProjectRisk`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        getRiskStatusCount: builder.query({
            query: ({ projectId, ...params }) => ({
                url: `ProjectRisk/project/${projectId}/summary`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["GetRiskStatusCount"],
        }),

        createProjectRisk: builder.mutation({
            query: ({ body }) => ({
                url: `ProjectRisk`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["ProjectRisks", "GetRiskStatusCount"],
        }),

        updateProjectRisk: builder.mutation({
            query: ({ body }) => ({
                url: `ProjectRisk`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["ProjectRisks"],
        }),

        getRiskComment: builder.query({
            query: ({ projectRiskId, ...params }) => ({
                url: `ProjectRiskComment/risk/${projectRiskId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["CommentList"]
        }),

        addProjectRiskComment: builder.mutation({
            query: (formData) => ({
                url: `ProjectRiskComment`,
                method: "POST",
                body: formData,
            }),
            invalidatesTags: ["CommentList"],
        }),

        getRiskAttachmentsByComment: builder.query({
            query: (commentId) => `/ProjectRiskComment/${commentId}/attachments`,
        }),

    }),
});

export const {
    useGetAllProjectRiskQuery,
    useLazyGetAllProjectRiskQuery,
    useLazyGetExportAllProjectRiskQuery,
    useGetRiskStatusCountQuery,
    useCreateProjectRiskMutation,
    useUpdateProjectRiskMutation,
    useAddProjectRiskCommentMutation,
    useGetRiskCommentQuery,
    useGetRiskAttachmentsByCommentQuery
} = projectRiskSlice;